import React from 'react';
import './styles.scss';
import Selections from 'components/ProductsSelection/Selections';
import { ProductSelection } from 'components/ProductsSelection/types';

interface Props {
  value: string;
  onNameChange: (value: string) => void;
  inputTitle: string;
  inputSubtitle: string;
  appliedSelection: ProductSelection;
  clientId: string;
  currentBrand: string;
}

const GroupName: React.FC<Props> = ({
  value,
  onNameChange,
  inputTitle,
  inputSubtitle,
  appliedSelection,
  clientId,
  currentBrand,
}) => (
  <div className="group-name-section">
    <div className="group-name-container">
      <div className="name-input-container">
        <h4>{inputTitle}</h4>
        <span>{inputSubtitle}</span>
        <input
          required
          className="name-input"
          placeholder="Name your group"
          value={value}
          onChange={(event) => onNameChange(event.target.value)}
        />
      </div>
    </div>
    <div className="selection-section">
      <Selections
        appliedSelection={appliedSelection}
        clientId={clientId}
        currentBrand={currentBrand}
        editable={false}
        title="Your Selection"
      />
    </div>
  </div>
);

export default GroupName;
